import {DOCK_MANAGE, DOCK_DOMAIN_MANAGE} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/dock/index.vue'),
    name: DOCK_MANAGE,
    path: 'dock',
    meta: {
        name: DOCK_MANAGE,
        title: '接入管理'
    },
    children: [{
        component: () => import('@/views/dock/domain/index.vue'),
        path: 'domain',
        name: DOCK_DOMAIN_MANAGE,
        meta: {
            name: DOCK_DOMAIN_MANAGE,
            title: '域名管理'
        }
    }]
};